<template>
    <div>
        <v-card max-width="100%" class="mx-auto" height="65vh" tile>
            <v-carousel :continuous="true" :cycle="false" :show-arrows="false" hide-delimiter-background delimiter-icon="remove" height="65vh" v-model="profile" v-on:change="checkProfile">
                <v-carousel-item v-for="(slide, i) in default_profiles" :key="i">
                    <v-sheet :color="colors[i]" height="100%" tile>
                        <v-row class="fill-height" justify="center">
                            <v-col cols="12" align="center">
                                <div class="display-3" style="margin-top: 80px;">{{ slide["name"] }}</div>
                            </v-col>

                            <v-col cols="12" align="center">
                                <p>{{ slide["desc"] }}</p>
                            </v-col>

                            <v-col cols="12" align="center">
                                <v-text-field outlined label="On,Off,On,Off duration in ms" placeholder="200,200,400,200"
                                              v-model="custom_pulse" v-if="custom_profile" style="margin-left: 50px; margin-right: 50px;"></v-text-field>
                            </v-col>

                        </v-row>
                    </v-sheet>
                </v-carousel-item>
            </v-carousel>
            <v-card-text style="height: 80px; position: relative;">
                <v-btn v-on:click="vibrate" absolute dark fab top :color="vibrate_btn_col" style="left: 50%; transform: translateX(-50%); height: 120px; width: 120px; top: -48px;">
                    <v-icon style="font-size: 48px;">{{ vibrate_icon }}</v-icon>
                </v-btn>

                <v-btn v-on:click="dialog = !dialog"  absolute dark fab top color="yellow darken-4" style="left: 75%; height: 58px; width: 58px; top: -32px;">
                    <v-icon>settings</v-icon>
                </v-btn>

            </v-card-text>
        </v-card>

        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title>Settings</v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field label="Repeat" placeholder="5" outlined type="number" v-model="repeat"></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="dialog = false">Done</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    const VIB_PULSE = {
        "Default": [500, 500],
        "Short Pulse": [100, 100],
        "Long Pulse": [1000, 750],
        "Fireman": [300, 100, 200, 100],
    };


    export default {
        name: "VibrateComponent",
        data () {
            return {
                default_profiles: [
                    { "name" : "Default", "desc" : "Normal vibration at a constant switch"
                    }, { "name" : "Short Pulse", "desc" : "Quick short pulses"
                    }, { "name": "Long Pulse", "desc": "Bzzzzzzzzzzzzzzz"
                    }, { "name" : "Fireman", "desc" : "Like a fire truck. BZZ bzz BZZ bzz"
                    }, { "name" : "Custom", "desc" : "Fine tune to your liking, or load your own profile"}
                ],
                custom_pulse: "",
                profile: 0,
                custom_profile: false,
                repeat: 5,
                vibrating: false,
                vibrate_icon: "vibration",
                vibrate_btn_col: "pink",
                colors: ['#388e3c','#424242','#ef6c00','#e53935','#0d47a1'],
                dialog: false
            }
        },
        methods: {
            vibrate(){
                if(!this.vibrating){
                    let pattern_chosen = (this.custom_profile) ? this.custom_pulse.split(",") : VIB_PULSE[this.default_profiles[this.profile]["name"]];
                    let pattern = [];

                    this.$gtag.event('vibrate', {'event_category': "vibrate_profile", 'event_label': this.default_profiles[this.profile]["name"] });

                    for(let i = 0; i < parseInt(this.repeat); i++){
                        pattern = pattern.concat(pattern_chosen);
                    }
                    this.startVibrate();

                    let durr = pattern.reduce((a,b) => parseInt(a) + parseInt(b), 0);
                    setTimeout(this.stopVibrate, parseInt(durr));

                    window.navigator.vibrate(pattern);
                } else {
                    this.stopVibrate();
                }

            },
            startVibrate(){
                this.vibrating = true;
                this.vibrate_icon = "insert_emoticon";
                this.vibrate_btn_col = "deep-purple darken-3";
                document.querySelector('meta[name="theme-color"]').setAttribute('content',  '#6a1b9a');
            },
            stopVibrate(){
                navigator.vibrate(0);
                this.vibrate_icon = "vibration";
                this.vibrate_btn_col = "pink";
                document.querySelector('meta[name="theme-color"]').setAttribute('content',  this.colors[this.profile]);
                this.vibrating = false;
            },
            checkProfile(){
                this.custom_profile = (this.default_profiles[this.profile]["name"] === "Custom");
                (!this.vibrating) && document.querySelector('meta[name="theme-color"]').setAttribute('content',  this.colors[this.profile]);
            }
        }
    }
</script>

<style>
    .m-fix{
        margin-top: 0px;
        margin-bottom: 0px;
    }

    .v-carousel__controls{
        top: 0;
    }
</style>